<script>
import { isImminent, isEnded } from '../../utils/Time';
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    targetTime: {
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    currentTime: {
      required: true,
    },
    islegacyFormat: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    imminent() {
      return isImminent(this.targetTime);
    },
    isEnded() {
      return isEnded(this.targetTime);
    },
  },
};
</script>

<template>
  <abbr
    :data-ticking="currentTime"
    :class="[{ 'imminent': imminent }, { 'is-ended': isEnded }, 'relative-time__inner']"
  >
    <span>{{ targetTime | countdown(islegacyFormat) }}</span>
  </abbr>
</template>
